import { render, staticRenderFns } from "./ObjectStoreTypeSpan.vue?vue&type=template&id=1cd6cfc2&scoped=true"
import script from "./ObjectStoreTypeSpan.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectStoreTypeSpan.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ObjectStoreTypeSpan.vue?vue&type=style&index=0&id=1cd6cfc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd6cfc2",
  null
  
)

export default component.exports